import {forwardRef} from 'react';
import InputMask from 'react-input-mask';
import cx from 'classnames';

import {Text, TextInput} from '#component/base';
import * as css from '#component/partial/TextInputField/TextInputField.css';
import {sprinkles} from '#style/sprinkles';

import {NumberInputFieldProps} from './NumberInputField.types';

export const NumberInputField = forwardRef<HTMLInputElement, NumberInputFieldProps>(
  (
    {
      className,
      disabled,
      errors,
      id,
      label,
      labelRightContent,
      labelBottomContent,
      name,
      message,
      ...otherProps
    },
    ref,
  ) => {
    const renderedId = id || name;
    const hasError = !!errors?.[name];

    return (
      <div className={cx(css.root({disabled}), className)}>
        <div className={sprinkles({content: 'between', flex: 'flex'})}>
          {label && (
            <Text
              as="label"
              color={hasError ? 'solidRed' : 'doveGray'}
              htmlFor={renderedId}
              variant="label">
              {label}
            </Text>
          )}
          {labelRightContent && (
            <Text color="doveGray" variant="caption">
              {labelRightContent}
            </Text>
          )}
        </div>

        <div className={sprinkles({flex: 'flex', dir: 'col', gap: 8})}>
          <TextInput
            as={InputMask}
            disabled={disabled}
            error={hasError}
            id={renderedId}
            name={name}
            ref={ref}
            {...otherProps}
          />

          {labelBottomContent && (
            <Text color="dustyGray" variant="caption">
              {labelBottomContent}
            </Text>
          )}
          {message && (
            <Text color={hasError ? 'solidRed' : 'burgundy'} className={css.message}>
              {message}
            </Text>
          )}

          {hasError && <Text color="solidRed">{errors?.[name]?.message}</Text>}
        </div>
      </div>
    );
  },
);
